// extracted by mini-css-extract-plugin
export var completionBody = "_lv-2";
export var completionCard = "_lv-0";
export var completionFooter = "_lv-3";
export var completionTitle = "_lv-1";